import { ArrowLeft } from "@bale/ui";
import { useTheme } from "@emotion/react";
import { strings } from "intl/fa";
import React from "react";
import styles from "./OrganizationAuthState.module.scss";
import { useAppDispatch } from "utils/store";
import { NavigationActions, AppPage } from "core/navigation/navigation.slice";
import { docsStateLabels } from "utils/auth";
import { useMyPanel } from "../../../../../hooks/useMyPanel";

export const OrganizationAuthState: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const myPanel = useMyPanel();
  const openAuthRequestDetailsPage = () => {
    dispatch(NavigationActions.setAppPage(AppPage.AuthRequestDetail));
  };

  return (
    <>
      <div className={styles.Container} onClick={openAuthRequestDetailsPage}>
        <div className={styles.Content}>
          <div className={styles.Title}>
            {strings.invoicing.docs_submission_request}
          </div>
          <div className={styles.Label}>
            {strings.ad_sale.ordered_ads_list.status}
            <p style={{ color: docsStateLabels(myPanel.state).color }}>
              {docsStateLabels(myPanel.state).label}
            </p>
          </div>
        </div>
        <ArrowLeft size={24} color={theme.colors.dark[500]} />
      </div>
    </>
  );
};
